(() => {
  if (window.productsGridCarouselLoaded) return;
  window.productsGridCarouselLoaded = true;

  const selector = '[data-products-grid-carousel]';
  const initialize = (root) => {
    if (!window.Swiper) return;

    root.querySelectorAll(selector).forEach((element) => {
      if (element.swiper) return;

      element.querySelectorAll(':scope > .swiper-wrapper > .product-card').forEach((card) => {
        card.classList.add('swiper-slide');
      });

      const swiper = new window.Swiper(element, {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 16 },
        },
        pagination: {
          el: element.querySelector('.products-grid__pagination'),
          clickable: true,
          renderBullet: (index, className) =>
            `<button type="button" class="${className}" aria-label="Go to slide ${index + 1}"></button>`,
        },
      });

      // Patrol 10-16: products scrolled out of view stay out of the Tab
      // order; the pagination buttons bring them in.
      const syncSlidesInert = () => {
        const rootRect = swiper.el.getBoundingClientRect();
        swiper.slides.forEach((slide) => {
          const slideRect = slide.getBoundingClientRect();
          slide.inert = slideRect.right <= rootRect.left + 1 || slideRect.left >= rootRect.right - 1;
        });
      };
      swiper.on('transitionEnd', syncSlidesInert);
      swiper.on('resize', syncSlidesInert);
      syncSlidesInert();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  window.addEventListener('load', () => initialize(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((element) => {
      element.swiper?.destroy(true, true);
    });
  });
})();
